import { useMemo } from "react";
import { Form, DatePicker, Select, Radio, InputNumber } from "antd";
import "./TypeOfWork.scss";
import { useState } from "react";
import { useSelector } from "react-redux";
import dayjsTZ from "../../../utils/dayjs";
const { Option } = Select;

const WORK_TYPE_FIELD_ID = "f418a4ca-6c0c-479a-9c04-1e244cb581da";
const PAYMENT_TYPE_FIELD_ID = "01d6ec94-5ddf-4f48-9fdc-86a39a7289d9";
const CONTRACT_DURATION_FIELD_ID = "01djhsgdfh-fuihwef-uifyuis39a7289d9";

const TypeOfWork = () => {
  const { programFields } = useSelector((state) => state.programFields);
  const { departments } = useSelector((state) => state.departments);
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [active, setActive] = useState(true);
  const [roles, setRoles] = useState();
  const [value, setValue] = useState(1);
  const [fixedPay, setFixedPay] = useState(true);
  const [hourPay, setHourPay] = useState(true);

  //! validates date
  const date = dayjsTZ([2018]);
  const correctDate = (current) => {
    return current && current < date;
  };

  //! get departmentRoles from departments
  const setRoleOptions = (value) => {
    setRoles(
      departments?.find(({ departmentName }) => departmentName === value)
        ?.departmentRoles
    );
  };

  const { workType, paymentType, contractDuration } = useMemo(() => {
    if (!programFields) return {};
    let workType = [];
    let paymentType = [];
    let contractDuration = [];

    for (const { fieldId, fieldOptions } of programFields) {
      if (fieldId === WORK_TYPE_FIELD_ID) {
        workType = fieldOptions;
      } else if (fieldId === PAYMENT_TYPE_FIELD_ID) {
        paymentType = fieldOptions;
      } else if (fieldId === CONTRACT_DURATION_FIELD_ID) {
        contractDuration = fieldOptions;
      }
    }
    return { workType, paymentType, contractDuration };
  }, [programFields]);

  return (
    <div className="typeOfWorkContainer">
      <div className="formContainer">
        <Form.Item
          className="input-container"
          name="employeeWorkStartDate"
          label="Data e Fillimit"
        >
          <DatePicker
            allowClear
            popupClassName={isDarkMode ? "darkDropdown" : ""}
            format="DD/MM/YYYY"
            className="work-date"
            placeholder="Selekto datën e fillimit të punës"
          />
        </Form.Item>
        <Form.Item
          className="input-container"
          name="employeeDepartmentName"
          label="Departamenti"
          rules={[
            {
              required: true,
              message: "Departamenti është i detyrueshëm",
            },
          ]}
        >
          <Select
            className="select-3"
            allowClear
            placeholder="Selekto departamentin"
            popupClassName={isDarkMode ? "darkDropdown" : ""}
            onSelect={setRoleOptions}
          >
            {(departments || []).map((departmentData) => (
              //* map all departments and gets departmentName from DB
              <Option value={departmentData.departmentName}>
                {departmentData.departmentName}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          className="input-container"
          name="employeeRoleName"
          label="Pozicioni"
          rules={[
            {
              required: true,
              message: "Pozicioni punonjësit është i detyrueshëm",
            },
          ]}
        >
          <Select
            allowClear
            className="select-3"
            placeholder="Selekto pozicionin e punës së punonjësit"
            popupClassName={isDarkMode ? "darkDropdown" : ""}
          >
            {roles?.map((roleData) => (
              //* map all roles from departments and gets name from DB
              <Option value={roleData?.name}>{roleData?.name}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          className="input-container"
          name="employeeTypeOfEmployment"
          label="Lloji i Punësimit"
          rules={[
            {
              required: true,
              message: "Lloji i punësimit është e detyrueshme",
            },
          ]}
        >
          <Select
            className="select-3"
            popupClassName={isDarkMode ? "darkDropdown" : ""}
            placeholder="Selekto llojin e punësimit"
            allowClear
          >
            {workType?.map((work) => (
              //* map workType for each work in DB
              <Option value={work}>{work}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          className="input-container"
          name="employeePayrollType"
          label="Mënyra e Pagesës"
          // value={view}
          rules={[
            {
              required: true,
              message: "Mënyra e pagesës është e detyrushme",
            },
          ]}
        >
          <Select
            className="select-3"
            placeholder="Selekto mënyrën e pagesës"
            allowClear
            popupClassName={isDarkMode ? "darkDropdown" : ""}
            //* makes employeeMonthlyNetSalary and emplyeeSalaryPerHour visible or not
            onSelect={(value) => {
              if (value === "Page Fikse") {
                setFixedPay(false);
                setHourPay(true);
              } else {
                setHourPay(false);
                setFixedPay(true);
              }
            }}
          >
            {paymentType?.map((pay) => (
              //* map paymentType for each payment on DB
              <Option value={pay.name}>{pay.name}</Option>
            ))}
          </Select>
        </Form.Item>
        {!fixedPay && (
          <Form.Item
            className="input-container"
            name="employeeMonthlyNetSalary"
            label="Paga neto mujore"
            hidden={fixedPay}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <InputNumber
              autoComplete="off"
              allowClear
              className="inputNumber"
              type="number"
              placeholder="Shkruaj pagën neto mujore"
            />
          </Form.Item>
        )}
        {!hourPay && (
          <Form.Item
            className="input-container"
            name="employeeSalaryPerHour"
            label="Paga për orë"
            hidden={hourPay}
          >
            <InputNumber
              autoComplete="off"
              type="number"
              className="inputNumber"
              placeholder="Shkruaj pagën për orë"
            />
          </Form.Item>
        )}
      </div>
      <div className="contractContainer">
        <Form.Item
          className="input-container"
          name="employeeContractType"
          label="Lloji i kontratës"
          rules={[
            {
              required: true,
              message: "Lloji i kontratës është i detyrueshëm",
            },
          ]}
        >
          <Radio.Group onChange={(e) => setValue(e.target.value)} value={value}>
            <Radio value={"E përcaktuar"} onClick={() => setActive(false)}>
              E përcaktuar
            </Radio>
            <Radio
              value={"E papërcaktuar"}
              onClick={() => {
                setActive(true);
              }}
            >
              E papërcaktuar
            </Radio>
          </Radio.Group>
        </Form.Item>
        {!active && (
          <div className="dates">
            <Form.Item
              className="content"
              name="employeeHireDate"
              label="Fillimi Kontratës"
              hidden={active}
            >
              <DatePicker
                format="DD/MM/YYYY"
                className="input"
                popupClassName={isDarkMode ? "darkDropdown" : ""}
                disabledDate={correctDate}
                placeholder="Selekto fillimin e kontratës"
              />
            </Form.Item>
            <Form.Item
              className="content"
              name="employeeContractDuration"
              label="Periudha e kontratës"
              hidden={active}
            >
              <Select
                className="inputDuration"
                placeholder="Selekto kohëzgjatjen e kontratës"
                popupClassName={isDarkMode ? "darkDropdown" : ""}
                allowClear
              >
                {contractDuration?.map((duration) => (
                  //* map employeeContractDuration for each payment on DB
                  <Option value={duration.name}>{duration.name}</Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        )}
      </div>
    </div>
  );
};

export default TypeOfWork;
